import styles from "./race-support.module.scss"
import { useEffect, useRef, useState, useContext } from "react"
import { AppContext } from "../../utils/context"

// UI components
import Background from "../../components/background/background"
import Arrow from "../../assets/images/icons/arrow.svg"
import OpsRoom from "./slides/ops-room/ops-room"
import PitWall from "./slides/pit-wall/pit-wall"

// Returns the HTML makrup for the race hub
export default function RaceSupport() {
	const [isFadedOut, setIsFadedOut] = useState(false)
	const [isFadedOutSwipe, setIsFadedOutSwipe] = useState(false)
	const [gridFadedOut, setGridFadedOut] = useState(true)

	// Scroll position trackers
	const [baseScrollPosition, setBaseScrollPosition] = useState(0)
	const [scrollPosition, setScrollPosition] = useState(50)

	// Ref to the slider
	const sliderRef = useRef(null)

	// Handle the scroll event
	const handleScroll = () => {
		// If the div ref is available
		if (sliderRef.current) {
			// Get the scroll left and screen width
			const scrollLeft = sliderRef.current.scrollLeft
			const screenWidth = window.innerWidth

			// Set the base scroll position into the state for the background
			setBaseScrollPosition(scrollLeft)

			// Work out the scroll left as a percentage of the screen width
			setScrollPosition((scrollLeft / screenWidth) * 100 * -0.25 + 50)

			// console.log(scrollLeft, screenWidth)
			setIsFadedOut(scrollLeft > screenWidth / 3)
			setIsFadedOutSwipe(scrollLeft > screenWidth / 6)
			setGridFadedOut(scrollLeft < screenWidth - 100)
		}
	}

	// On component mount
	useEffect(() => {
		// If the div ref is available
		if (sliderRef.current) {
			// Add event listener
			sliderRef.current.addEventListener("scroll", handleScroll)
		}

		// Cleanup event listener
		return () => {
			if (sliderRef.current) {
				sliderRef.current.removeEventListener("scroll", handleScroll)
			}
		}
	}, [])

	return (
		<>
			<Background />

			<div
				className={styles.slider}
				ref={sliderRef}>
				<div className={styles.slide}>
					<PitWall />
				</div>
				<div className={styles.slide}>
					<OpsRoom />
				</div>
			</div>

			<div className={[styles.swipe, isFadedOutSwipe ? styles.fadeOut : ""].join(" ").trim()}>
				<img
					src={Arrow}
					alt="Left Arrow"
				/>
			</div>
		</>
	)
}
